import type { GetApiTokenDetailViewModel } from "@vintecc/capture-api-types/v1";
import { normalizeUtcTimestamp } from "@/helpers/date";

import { queryClient } from "@/queryClient";
import { useApiTokenStore } from "@/store/apiTokenStore";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/api-tokens/$id")({
  staticData: {
    title: "apiTokens.title",
  },
  loader: async ({ params: { id } }) => {
    const [{ formatPermissionsByApp }, { queries, requests }] = await Promise.all([
      import("@/modules/identity-and-access/api-tokens/helpers/detail"),
      import("@/modules/identity-and-access/api-tokens/services/requests"),
    ]);

    const data = await queryClient.ensureQueryData(queries.getApiTokenById(+id));

    const permissions = id ? (await requests.getPermissions(Number(id))).data.modules : [];

    const { setToken } = useApiTokenStore.getState();

    const formattedPermissions = formatPermissionsByApp(permissions || []);

    const defaultTokenData = {
      ...data,
      permissions: formattedPermissions,
      expiration: data?.expiration ? normalizeUtcTimestamp(data.expiration) : null,
    };
    setToken(defaultTokenData as GetApiTokenDetailViewModel);
    return data;
  },
});
